export default theme => {
    return {
        
    }
}


// WEBPACK FOOTER //
// ./src/app/configuration/Template/theme/components/selection/Search/ExtraFilter.js